var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-splitter'),_c('v-ons-toast',{attrs:{"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_vm._v(" "+_vm._s(_vm.visible ? _vm.active.message : '')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }